module.exports = __webpack_public_path__ + "static/img/makehole7.ab5bd0cf.png";